import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
          <p>
<strong>Welcome to Experiment 3: DES Decryption Simulator!</strong> Building on the foundation established in Experiments 1 and 2, this module delves deeper into the DES algorithm, focusing on the decryption process of ciphertext.
<br /><br />
→ Begin by inputting a 64-bit binary sequence, representing your ciphertext, and the associated Decryption Key. Once entered, click "Next" to initiate the decryption. The data, for ease of understanding, is showcased as a matrix.
<br /><br />

→ Use the "next" and "previous" buttons to maneuver through each decryption round. Observe the intricacies of operations on both the left and right 32 bits as the ciphertext undergoes transformation.
<br /><br />

→ After progressing through the initial k rounds, test your understanding by computing the k+1th intermediate decryption result. Succeeding in this task will grant you access to the subsequent stages of the simulation.
<br /><br />

→ Stumble upon an error? The simulator stands ready with feedback, guiding you towards the right path. The "PREVIOUS" button allows for a swift backtrack to refine your understanding.
<br /><br />

→ The culmination of this experiment hinges on your ability to discern the final 32-bit left and right decrypted outputs.
<br /><br />


→ To Complete this Experiment the student has to identify the 32-bit left and right output
<br /><br />


<strong>Tip:</strong> Keeping a technical journal on hand can be invaluable. Jot down observations, insights, and potential questions. This interactive journey is designed not just to demonstrate but to instill a profound understanding of the DES decryption mechanics. Engage deeply to unlock the nuances
          </p>
        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
